import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { SPRITE_ID } from 'app/constants';

@Injectable({
    providedIn: 'root',
})
export class SpriteService {
    private http = inject(HttpClient);

    private spriteLoaded = new BehaviorSubject<boolean>(false);
    spriteLoaded$ = this.spriteLoaded.asObservable();

    constructor() {
        this.loadSprite();
    }

    private loadSprite() {
        if (document.getElementById(SPRITE_ID)) {
            this.spriteLoaded.next(true);
            return;
        }

        this.http.get('assets/images/sprite.svg', { responseType: 'text' }).subscribe((sprite) => {
            const div = document.createElement('div');
            div.id = SPRITE_ID;
            div.style.display = 'none';
            div.innerHTML = sprite;
            document.body.insertBefore(div, document.body.firstChild);
            this.spriteLoaded.next(true);
        });
    }
}
